import React, {createContext, useReducer} from "react";
import {jwtDecode} from "jwt-decode";
import {AUTH_TOKEN} from "../constants";
import client from '../apolloClient'
import {useQuery} from "@apollo/client";
import {getCurrentUser} from "../components/users/UserQueries";

const initialState = {
  user: null,
  logged: false
}
console.log(localStorage.getItem(AUTH_TOKEN))
if (localStorage.getItem(AUTH_TOKEN) && localStorage.getItem(AUTH_TOKEN) !== 'undefined') {
  const decodedToken = jwtDecode(localStorage.getItem(AUTH_TOKEN))
  // console.log('decodedToken - ', decodedToken)
  if (decodedToken.exp * 1000 < Date.now()) {
    console.log('expired - logout')
    localStorage.removeItem(AUTH_TOKEN)
    initialState.logged = false
  } else {
    // console.log('autologin - ', decodedToken.user)
    initialState.user = { id: decodedToken.user.id, type: decodedToken.user.type }
    initialState.logged = true
  }
}
localStorage.getItem('forceReload', false)

const AuthContext = createContext({
  user: null,
  saveUser: (userData) => {
  },
  login: (userData, redirectPath) => {
  },
  logout: () => {
  }
})

function authReducer(state, action) {
  switch (action.type) {
    case 'LOGIN':
      return {
        ...state,
        user: action.payload.user,
        logged: true
      }
    case 'LOGOUT':
      return {
        ...state,
        user: null,
        logged: false
      }
    case 'RELOAD_USER':
      return {
        ...state,
        user: {
          ...state.user,
          email: null
        },
        logged: false
      }
    case 'USER_DATA':
      return {
        ...state,
        user: action.payload
      }
    default:
      return state
  }
}

function AuthProvider(props) {
  const [state, dispatch] = useReducer(authReducer, initialState);
  const { data, refetch } = useQuery(getCurrentUser, { skip: !state.logged })

  const saveUser = (userData) => {
    dispatch({ type: 'USER_DATA', payload: userData })
  }

  const login = async (userData, redirectPath = '/') => {
    // console.log('login - ', userData)
    localStorage.setItem(AUTH_TOKEN, userData.token)
    await dispatch({ type: 'LOGIN', payload: userData })
    window.location = redirectPath
  }

  const logout = () => {
    client.cache.reset()
    localStorage.removeItem(AUTH_TOKEN)
    dispatch({ type: 'LOGOUT' })
  }

  const reloadUser = () => {
    localStorage.setItem('forceReload', true)
    refetch()
  }

  if (data && (localStorage.getItem('forceReload') === 'true' || !state.user.email)) {
    localStorage.setItem('forceReload', false)
    saveUser(data.me)
  }

  return (
    <AuthContext.Provider value={{ user: state.user, saveUser, login, logout, reloadUser }} {...props} />
  )
}

export {AuthContext, AuthProvider}
